/**
 * Mobile sticky Add to Cart. Shows once the page's main Add to Cart button scrolls out of view and
 * presses that real button, so the selected variant and quantity are always used.
 */
class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const mainButton = () => document.querySelector('[data-product-form] button[name="add"]');
    // Watch the stable form wrapper; the button inside is re-rendered when options change.
    const target = document.querySelector('[data-product-form]');
    if (!target || !mainButton()) return;
    this.hidden = false;
    this.#observer = new IntersectionObserver(([entry]) => {
      const pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.classList.toggle('translate-y-full', !pastButton);
      this.toggleAttribute('inert', !pastButton);
    });
    this.#observer.observe(target);
    this.querySelector('[data-sticky-atc-button]')?.addEventListener('click', () => {
      const button = mainButton();
      if (button && !button.disabled) button.click();
    });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}
if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', SStickyAtc);
